export const CONTACTOS_TABLE_FILTER = () => ({
  etiquetasSelected: [],
  keyword: undefined,
  pagination: {
    itemsPerPage: 100,
    skipCount: 0,
  },
})

export type ContactosTableProps = {
  etiquetasSelected: Array<string>
  keyword: string
  pagination: {
    itemsPerPage: number
    skipCount: number
  }
}
